import { Flex, Tooltip, FormLabel, Icon, Box } from '@chakra-ui/react';
import { CustomInfoOutlineIcon } from '../../../theme/icons/CustomInfoOutlineIcon';

export const LabelWithTooltip = ({
  label,
  tooltip,
}: {
  label: string;
  tooltip: string;
}) => {
  return (
    <Flex alignItems="center" mb={3} gap={2}>
      <FormLabel variant="templateBuilderLabel" m={0} lineHeight="1">
        {label}
      </FormLabel>
      {tooltip && (
        <Tooltip
          label={tooltip}
          hasArrow
          placement="top"
          fontSize="12px"
          bg="inkBlue"
          color="white"
          borderRadius="6px"
          textAlign="center"
          p="10px"
        >
          <Box as="span" cursor="pointer" display="flex" alignItems="center">
            <Icon as={CustomInfoOutlineIcon} boxSize={4} fill="grey" />
          </Box>
        </Tooltip>
      )}
    </Flex>
  );
};
